import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { EchartService } from '../../../../core/services/echart.service';
import { Router } from '@angular/router';
import { TabService } from '../../../../core/services/tab.service';


@Component({
  selector: 'app-property-type',
  templateUrl: './property-type.component.html',
  styleUrls: ['./property-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class PropertyTypeComponent implements OnInit, AfterViewInit {
  @ViewChild('myCharts') myCharts: ElementRef;
  @Input() projectId: any;
  echartsInstance: any;
  dataSource: any;
  noData: any;
  option = {
    color: [],
    title: {
      text: 'Property Type',
      top: '30px',
      left: '20px',
      textStyle: {
        fontFamily: 'Poppins SemiBold',
        fontSize: 14
      }
    },
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b} : {c} ({d}%)'
    },
    legend: {
      orient: 'vertical',
      top: '60px',
      left: '20px',
      itemHeight: '10',
      // data: ['Available', 'EOI', 'Reserved', 'Exchange conditional', 'Unconditional', 'Settled']
      data: [],
    },
    series: [
      {
        name: 'Property Type',
        type: 'pie',
        radius: ['40%', '60%'],
        center: [],
        label: false,

        // data: [
        //   {value: 335, name: 'Available'},
        //   {value: 310, name: 'EOI'},
        //   {value: 234, name: 'Reserved'},
        //   {value: 135, name: 'Exchange conditional'},
        //   {value: 135, name: 'Unconditional'},
        //   {value: 135, name: 'Settled'}
        // ],
        data: [],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  };


  constructor(private echartService: EchartService, private cdr: ChangeDetectorRef, private router: Router, private tabService: TabService) {
  }

  ngOnInit(): void {
    this.option = {
      color: [],
      title: {
        text: 'Property Status',
        top: '30px',
        left: '20px',
        textStyle: {
          fontFamily: 'Roboto',
          fontSize: 10
        }
      },
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)'
      },
      legend: {
        orient: 'vertical',
        top: '60px',
        left: '20px',
        // align: 'left',
        // itemWidth: '10',
        itemHeight: '10',
        data: [],
      },
      series: [
        {
          name: 'Property Status',
          type: 'pie',
          radius: ['35%', '50%'],
          center: ['55%', '65%'],
          label: false,
          data: [],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };

    this.echartService.getPropertyStatus(this.projectId).subscribe((res: any) => {
      console.log(res, this.projectId);
      this.dataSource = res.data[0];
      const propertyTpeData = new Object();
      if (Object.keys(res.data[0]).length > 0) {
        if (0 in this.dataSource) {
          propertyTpeData['Unavailable'] = this.dataSource['0'];
          this.option.legend.data.push('Unavailable');
          this.option.color.push('#FF0D90');
        }
        if (1 in this.dataSource) {
          propertyTpeData['Available'] = this.dataSource['1'];
          this.option.legend.data.push('Available');
          this.option.color.push('#05CD99');
        }
        if (2 in this.dataSource) {
          propertyTpeData['EOI'] = this.dataSource['2'];
          this.option.legend.data.push('EOI');
          this.option.color.push('#8676FF');
        }
        if (3 in this.dataSource) {
          propertyTpeData['Reserved'] = this.dataSource['3'];
          this.option.legend.data.push('Reserved');
          this.option.color.push('#A7E7F2');

        }
        if (4 in this.dataSource) {
          propertyTpeData['Exchange conditional'] = this.dataSource['4'];
          this.option.legend.data.push('Exchange conditional');
          this.option.color.push('#454F85');

        }
        if (5 in this.dataSource) {
          propertyTpeData['Unconditional'] = this.dataSource['5'];
          this.option.legend.data.push('Unconditional');
          this.option.color.push('#E95513');

        }
        if (6 in this.dataSource) {
          propertyTpeData['Settled'] = this.dataSource['6'];
          this.option.legend.data.push('Settled');
          this.option.color.push('#7165BE');
        }
        for (const type in propertyTpeData) {
          this.option.series[0].data.push({
            value: propertyTpeData[type],
            name: type
          });
        }
        this.cdr.detectChanges();
        console.log(propertyTpeData);
        if (this.echartsInstance) {
          console.log(this.option);
          this.echartsInstance.setOption(this.option);
        }
      } else {
        this.noData = true;
      }
    });
  }

  ngAfterViewInit(): void {
    // this.myCharts.chsetOption(this.option);
    // console.log(this.myCharts);

    // this.echartsInstance.();
    // this.myCharts.eresize();
  }

  onChartInit(ec) {
    console.log(ec);
    // ec.resize();
    this.echartsInstance = ec;
  }

  goToProject() {
    this.router.navigateByUrl('/projects/' + this.projectId + '/edit').then(() => {
      this.tabService.tabIndex = 7;
    });
  }
}
